import * as wjcCore from '@mescius/wijmo';
import * as wjcGrid from '@mescius/wijmo.grid';
import * as wjOlap from '@mescius/wijmo.olap';

declare var Stimulsoft: any;

'use strict';

import {ViewChild, Component, OnInit, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {Store} from '@ngrx/store';

import {ToasterService} from 'angular2-toaster';
import {TranslocoService} from '@jsverse/transloco';
import {ActivePromotionConfig} from '../config/active-promotion.config';
import {asOrientDate, DataService, isOrientDate} from '@cosbeni/database';
import {saveAs} from 'file-saver';
import {StimulsoftFontService} from "../services/stimulsoft-font.service";

@Component({
    standalone: false,
    selector: 'cj-admin-summary',
    templateUrl: 'summary-management.component.html',
})

export class SummaryManagementComponent implements OnInit, OnDestroy {
    readonly: Boolean = true;
    @ViewChild('auctionGrid') auctionGrid: wjcGrid.FlexGrid;
    @ViewChild('pivotGrid', {static: true}) pivotGrid: wjOlap.PivotGrid;
    auctionDate: string;
    auctionPlace: string;
    customer: any = {};
    invoices: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    invoiceLines: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    invoiceHeads: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    mode: string = 'view';
    pivot: wjOlap.PivotEngine;
    optionAuction: any[] = [];
    optionPlace: any[] = [];
    optionStatus: any[] = [];
    optionLane: any[] = [];
    selectAll: Boolean = false;
    viewer: any;
    viewerOptions: any;
    report: any;
    reportTemplate: any = {};
    private langSub: Subscription;

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private stimulsoftFontService: StimulsoftFontService, private transloco: TranslocoService) {
        this.dataService.query({
            sql: 'SELECT FROM DA_Auction order by eventDate DESC',
            count: 'SELECT FROM DA_Auction order by eventDate DESC',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                let auctionDates: any[] = [];
                for (let item of data.results) {
                    if (isOrientDate(item.eventDate)) {
                        item.eventDate = asOrientDate(item.eventDate);
                        let auctionDate = wjcCore.Globalize.formatDate(item.eventDate, 'yyyy/MM/dd');
                        auctionDates.push(auctionDate);
                    }
                }
                let set = new Set(auctionDates);
                this.optionAuction = Array.from(set);
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'会場名\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'会場名\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.optionPlace = [];
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.optionPlace.push(item.value);
                }
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'開催状態\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'開催状態\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.optionStatus = [];
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.optionStatus.push(item.value);
                }
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'レーン\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'レーン\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.optionLane = [];
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.optionLane.push(item.value);
                }
            }
        });
        this.mode = 'view';
    }

    ngOnInit() {
        Stimulsoft.Base.StiLicense.Key = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHl26ZSMEMFmk3V4cVIW/z4aEPCZyhHy36IUIO31u64kPjupS5' +
            'RJ4Kkjh5zA8Js69gML1a/uLIe1uPsavO7G5SbuLvcEW0DcE58buMSZAh4scMesvQVrMM5AkiDUBomhUQfwCMrOWHM9' +
            '61Nb0khu5OVxh450w7X/qNMLW/Ncr+Djtsa1cbZzEQ4r7VkoHy7uZEPVVX9G3Qqtt/dB0cY62D4SY5Zal1nD/bV66S' +
            '3ok4BE+uUYDR5LQ+Yr1dtr+aM/BJUdeMdY6UGOaMthyAGzcyJ1CfV+9AQNrprnDoMQLK83sxIpn5aTSX/p/LNdTCZa' +
            'gpBGH4fp2hjcWVrAsVgkNVsL9zaA0v83O3CtoSlmJLK7M7IAmtsV3fyy3LRo6PlMmBmsPJMbsfQdIj9krxN3Hx9IEQ' +
            'QpIyo+/vGqtsCpDAFfQAmcv6UfTYw0j3XWdoiRQWNBhOjx1jRZwogSJ0wzdVnqa78HySzEfTFNpyWyiPFl7WBxTNnB' +
            'wAVazg9gu7dVCbvUJJA+BRdINej8KErdRgfy';
        // フォント/ローカライズは StimulsoftFontService が 1 回だけ非同期登録する (ira issue #151 と同対応)
        this.stimulsoftFontService.ensureLoaded();
        this.viewerOptions = new Stimulsoft.Viewer.StiViewerOptions();
        this.viewerOptions.appearance.scrollbarsMode = false;
        this.viewer = new Stimulsoft.Viewer.StiViewer(this.viewer, 'StiViewer', false);
        this.report = new Stimulsoft.Report.StiReport();
        // 言語切替時はピボットの表示見出しを組み直す
        this.langSub = this.transloco.langChanges$.subscribe(() => {
            if (this.pivot) {
                this.buildPivot();
            }
        });
    }

    ngOnDestroy(): void {
        this.langSub?.unsubscribe();
    }

    onAuctionChanged(): void {
        if (!wjcCore.isNullOrWhiteSpace(this.auctionDate) && !wjcCore.isNullOrWhiteSpace(this.auctionPlace)) {
            let auctionDate = this.auctionDate.replace(/\//gi, '-');
            let auctionPlace = this.auctionPlace;
            this.dataService.query({
                sql: 'SELECT FROM DA_Invoice WHERE auctionDate = DATE(\'' + auctionDate + '\',\'yyyy-MM-dd\') AND auctionPlace = \'' + auctionPlace + '\' ORDER BY sort',
                count: 'SELECT FROM DA_Invoice WHERE auctionDate = DATE(\'' + auctionDate + '\',\'yyyy-MM-dd\') AND auctionPlace = \'' + auctionPlace + '\' ORDER BY sort',
                fetchPlan: '*:1',
            }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                if (wjcCore.isArray(data.results)) {
                    for (let item of data.results) {
                        if (wjcCore.isObject(item) && isOrientDate(item.auctionDate)) {
                            item.auctionDate = asOrientDate(item.auctionDate);
                        }
                    }
                    this.invoices.sourceCollection = data.results;
                    this.getHeads();
                }
            });
        }
        this.invoices.currentChanged.addHandler(this.onCurrentChanged, this);
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
        if (this.invoices.currentItem != null) {
            this.dataService.query({
                sql: 'SELECT FROM DA_Invoice_Head WHERE invoice =' + this.invoices.currentItem['@rid'] + ' ORDER BY sort',
                count:'SELECT FROM DA_Invoice_Head WHERE invoice =' + this.invoices.currentItem['@rid'] + ' ORDER BY sort',
                fetchPlan: '*:1',
            }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                if (wjcCore.isArray(data.results)) {

                }
            });
            this.dataService.query({
                sql: 'SELECT FROM DA_Invoice_Line WHERE invoice =' + this.invoices.currentItem['@rid'] + ' ORDER BY sort',
                count:'SELECT FROM DA_Invoice_Line WHERE invoice =' + this.invoices.currentItem['@rid'] + ' ORDER BY sort',
                fetchPlan: '*:1',
            }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                this.invoiceLines.sourceCollection = [];
                if (wjcCore.isArray(data.results)) {
                    this.invoiceLines.sourceCollection = data.results;
                }
                this.invoiceLines.refresh();
            });
        }
    }

    getHeads() {
        let auctionDate = this.auctionDate.replace(/\//gi, '-');
        let auctionPlace = this.auctionPlace;
        this.dataService.query({
            sql: 'SELECT FROM DA_Invoice_Head WHERE invoice.auctionDate = DATE(\'' + auctionDate + '\',\'yyyy-MM-dd\') AND invoice.auctionPlace = \'' + auctionPlace + '\' ORDER BY sort',
            count: 'SELECT FROM DA_Invoice_Head WHERE invoice.auctionDate = DATE(\'' + auctionDate + '\',\'yyyy-MM-dd\') AND invoice.auctionPlace = \'' + auctionPlace + '\' ORDER BY sort',
            fetchPlan: '*:1 invoice:2',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.invoiceHeads.sourceCollection = [];
                for (let item of data.results) {
                    if (wjcCore.isObject(item.invoice) && isOrientDate(item.invoice.auctionDate)) {
                        item.invoice.auctionDate = asOrientDate(item.invoice.auctionDate);
                    }
                    let head = {
                        '顧客ID': item.invoice.customer.name,
                        '顧客名': item.invoice.customerName,
                        '売買種類': item.tradeType,
                        '金額': item.amount,
                        '歩銭': item.fee,
                        '消費税': item.tax,
                        '合計': item.total,
                        '開催日': item.invoice.auctionDate,
                    };
                    this.invoiceHeads.sourceCollection.push(head);
                }
                this.invoiceHeads.refresh();
                this.buildPivot();
            }
        });
    }

    /** 集計ピボット。binding (データキー) は日本語固定、header (表示) のみ翻訳する。rowFields 等は header で参照される。 */
    buildPivot(): void {
        const h = (binding: string, key: string) => ({binding: binding, header: this.transloco.translate(key)});
        const fields = {
            eventDate: h('開催日', 'admin.event_date'),
            customerId: {...h('顧客ID', 'admin.customer_id'), width: 200},
            customerName: {...h('顧客名', 'admin.customer_name'), width: 200},
            tradeType: h('売買種類', 'admin.trade_type'),
            amount: h('金額', 'admin.amount'),
            fee: h('歩銭', 'admin.commission'),
            tax: h('消費税', 'admin.consumption_tax'),
            total: h('合計', 'admin.total'),
        };
        this.pivot = new wjOlap.PivotEngine(
            {
                autoGenerateFields: false,
                itemsSource: this.invoiceHeads,
                showColumnTotals: wjOlap.ShowTotals.GrandTotals,
                showRowTotals: wjOlap.ShowTotals.GrandTotals,
                fields: [fields.eventDate, fields.customerId, fields.customerName, fields.tradeType, fields.amount, fields.fee, fields.tax, fields.total],
                rowFields: [fields.customerId.header, fields.customerName.header],
                columnFields: [fields.tradeType.header],
                valueFields: [fields.amount.header, fields.fee.header, fields.tax.header, fields.total.header],
                showZeros: true
            }
        );
    }

    createInvoice() {
        let auctionDate = this.auctionDate.replace(/\//gi, '-');
        let auctionPlace = this.auctionPlace;
        this.dataService.post({
            auctionDate: auctionDate,
            auctionPlace: auctionPlace,
        }, ActivePromotionConfig.SERVER_URL + '/rest/auction/invoice').subscribe(data => {
            console.log(data);
        });
    }

    generatePDF(name) {
        if (this.mode == 'view') {
            if (this.reportTemplate.hasOwnProperty('name') && this.reportTemplate.name == name) {
                this.exportPDF(name);
            } else {
                this.dataService.query({
                    sql: 'SELECT FROM DA_Report WHERE name =\'' + name + '\'',
                    count: 'SELECT FROM DA_Report WHERE name =\'' + name + '\'',
                    fetchPlan: '*:1',
                }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                    if (wjcCore.isArray(data.results) && data.results.length == 1) {
                        this.reportTemplate = data.results[0];
                        this.exportPDF(name);
                    }
                });
            }
        }
    }

    async exportPDF(name) {
        await this.stimulsoftFontService.ensureLoaded();
        let r = (JSON.parse(JSON.stringify(this.reportTemplate.content)));
        delete r['@type'];
        delete r['@version'];
        this.report = new Stimulsoft.Report.StiReport();
        this.report.load(r);
        this.report.dictionary.databases.clear();
        let data: any = {};
        data.auction = {
            '日付': this.auctionDate,
            '合計金額': 0
        };
        data.summary = [];
        for (let summary of this.invoiceHeads.items) {
            if (summary['顧客']['@rid'] == this.customer['@rid']) {
                data.summary.push(summary);
            }
        }
        data.detail = [];
        for (let item of this.invoiceLines.items) {
            let detail = {ID: item.id};
            if (item.seller['@rid'] == this.customer['@rid']) {
                let sellerPercentage = item.sellerCharge * 100;
                let field = '売' + sellerPercentage + '%';
                if (item.quantity < 0) {
                    field = '売返';
                }
                detail['売買種類'] = field;
                detail['金額'] = Math.abs(item.quantity) * item.auctionPrice;
                if (Math.abs(item['個数']) > 1) {
                    detail['付加情報'] = Math.abs(item.quantity) + ' x ' + item.auctionPrice;
                }
                detail['商品名'] = item.name;
                detail['相手'] = item.buyer.memberName;
            }
            if (item.buyer['@rid'] == this.customer['@rid']) {
                let buyerPercentage = item.buyerCharge * 100;
                let field = '買' + buyerPercentage + '%';
                if (item.quantity < 0) {
                    field = '買返';
                }
                detail['売買種類'] = field;
                detail['金額'] = Math.abs(item.quantity) * item.auctionPrice;
                if (Math.abs(item['個数']) > 1) {
                    detail['付加情報'] = Math.abs(item.quantity) + ' x ' + item.auctionPrice;
                }
                detail['商品名'] = item.name;
                detail['相手'] = item.seller.memberName;
            }
            if (detail['金額'] > 0) {
                data.detail.push(detail);
            }
        }
        data.customer = {
            ID: this.customer.name,
            '名称': this.customer.memberName
        };
        for (let summary of data.summary) {
            data.auction['合計金額'] = data.auction['合計金額'] + summary['合計'];
        }
        console.log(data);
        let dataSet = new Stimulsoft.System.Data.DataSet('data');
        dataSet.readJson(data);
        this.report.regData(dataSet.dataSetName, 'data', dataSet);
        var pdfSettings = new Stimulsoft.Report.Export.StiPdfExportSettings();
        pdfSettings.embeddedFonts = true;
        var pdfService = new Stimulsoft.Report.Export.StiPdfExportService();
        var stream = new Stimulsoft.System.IO.MemoryStream();
        var report = this.report;
        this.viewer.report = this.report;
        var viewer = this.viewer;
        report.renderAsync(function () {
            viewer.renderHtml('viewerContent');
            /*
            pdfService.exportToAsync(function () {
                var data = stream.toArray();
                var blob = new Blob([new Uint8Array(data)], {type: "application/pdf"});
                saveAs(blob, name + ".pdf");
            }, report, stream, pdfSettings);
             */
        }, false);

    }

    refresh(grid: string): void {
        this[grid].invalidate();
    }

}

